import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <div className="relative z-10 max-w-md">
        <span className="inline-flex w-16 h-16 items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-5">
          <i className="ri-film-line text-3xl"></i>
        </span>
        <h1 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl mb-3">
          页面走丢了
        </h1>
        <p className="text-sm md:text-base text-foreground-500 mb-8 leading-relaxed">
          你访问的页面不存在或已被移动，回到首页继续追《善良的小姨子》吧。
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
            返回首页
          </Link>
          <Link
            to="/category/plot"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-list-2-line w-4 h-4 flex items-center justify-center"></i>
            查看剧情
          </Link>
        </div>
      </div>
    </div>
  );
}